import { checkVAT, spain, italy, france, portugal, germany } from 'jsvat'

const VALIDATIONS = {
  ES: spain,
  IT: italy,
  FR: france,
  PT: portugal,
  DE: germany,
}

const validateVAT = (vat, country) => {
  const validator = VALIDATIONS[country]
  vat = {
    ES: `ES${vat}`,
    IT: `IT${vat}`,
    FR: `FR${vat}`,
    PT: `PT${vat}`,
    DE: `DE${vat}`,
  }[country]

  // Default country ES doesn't have a prefix
  return validator ? checkVAT(vat, [validator]).isValid : true
}

export default validateVAT
